export const XPRESSID_EVENTS_ORIGIN = 'xpressid';
export const XPRESSID_IFRAME_DEV_URL = 'https://xpressid-web-work.eu.veri-das.com/v2';
export const XPRESSID_IFRAME_URL = 'https://xpressid-web.eu.veri-das.com/v2';
export const MESSAGE_EVENT_TYPE = 'message';
export const XPRESSID_INFO_EVENTS = {
    ProcessCompleted: 'ProcessCompleted',
    ProcessCancelled: 'ProcessCancelled',
    ProcessSigned: 'ProcessSigned',
    ProcessSignatureRejected: 'ProcessSignatureRejected',
    ProcessEvents: 'ProcessEvents',
};
export const XPRESSID_ERROR_EVENTS = {
    ValidationError: 'ValidationError',
    ErrorProcessingRequest: 'ErrorProcessingRequest',
    ErrorUpdateValidation: 'ErrorUpdateValidation',
    DocumentTypeMismatchError: 'DocumentTypeMismatchError',
    UnknownDocumentTypeError: 'UnknownDocumentTypeError',
    UnknownAnalysisTypeError: 'UnknownAnalysisTypeError',
    InvalidData: 'InvalidData',
    ScoresConfigurationNotAllowed: 'ScoresConfigurationNotAllowed',
    ScoresConfigurationError: 'ScoresConfigurationError',
    InvalidScoresConfigurationField: 'InvalidScoresConfigurationField',
    UnallowedLeversError: 'UnallowedLeversError',
    DocumentAnalysisError: 'DocumentAnalysisError',
    EmptyDocumentError: 'EmptyDocumentError',
    InvalidImageType: 'InvalidImageType',
    ImageAlreadyAnalyzedError: 'ImageAlreadyAnalyzedError',
    ErrorProcessingFile: 'ErrorProcessingFile',
    DocumentServiceNotReachable: 'DocumentServiceNotReachable',
    DocumentNfcUnavailableError: 'DocumentNfcUnavailableError',
    BlurredImageError: 'BlurredImageError',
    AdditionalDocumentProcessError: 'AdditionalDocumentProcessError',
    DocumentAnalyzingError: 'DocumentAnalyzingError',
    DocumentDetectionTimeout: 'DocumentDetectionTimeout',
    SelfieDetectionTimeout: 'SelfieDetectionTimeout',
    VideoDetectionTimeout: 'VideoDetectionTimeout',
    DocumentMountFailure: 'DocumentMountFailure',
    SelfieMountFailure: 'SelfieMountFailure',
    VideoMountFailure: 'VideoMountFailure',
    TokenNotAllowed: 'TokenNotAllowed',
    PassportNotFound: 'PassportNotFound',
};
export const XPRESSID_EVENTS = { ...XPRESSID_INFO_EVENTS, ...XPRESSID_ERROR_EVENTS };

export const XPRESSID_INFO_EVENTS_TYPE = 'info';
export const XPRESSID_ERROR_EVENTS_TYPE = 'error';

export const XPRESSID_INFO_EVENTS_QR_CODES = {
    QRProcessStarted: 'QRProcessStarted',
    QRContinueOnDesktop: 'QRContinueOnDesktop',
    QRProcessFinished: 'QRProcessFinished',
    QRProcessCaptured: 'QRProcessCaptured',
    QRClosedModal: 'QRClosedModal',
    QRProcessOnboardingError: 'QRProcessOnboardingError',
    QRProcessCancelled: 'QRProcessCancelled',
    QRProcessCompleted: 'QRProcessCompleted',
};
export const XPRESSID_INFO_EVENTS_DOCUMENT_CAPTURE_CODES = {
    DocumentProcessStarted: 'DocumentProcessStarted',
    DocumentMounted: 'DocumentMounted',
    DocumentUnmounted: 'DocumentUnmounted',
    DocumentRestartProcess: 'DocumentRestartProcess',
    DocumentProcessFinished: 'DocumentProcessFinished',
    DocumentCameraStarted: 'DocumentCameraStarted',
    DocumentCameraVideoPlayStarted: 'DocumentCameraVideoPlayStarted',
    DocumentObverseDetection: 'DocumentObverseDetection',
    DocumentReverseDetection: 'DocumentReverseDetection',
    DocumentManualCapture: 'DocumentManualCapture',
    DocumentSuccessTickFinish: 'DocumentSuccessTickFinish',
    DocumentOrientationChanged: 'DocumentOrientationChanged',
    DocumentRepeatClicked: 'DocumentRepeatClicked',
    DocumentRestartClicked: 'DocumentRestartClicked',
    DocumentDependenciesError: 'DocumentDependenciesError',
    DocumentMountFailure: 'DocumentMountFailure',
    DocumentCameraFailure: 'DocumentCameraFailure',
    DocumentDetectionTimeout: 'DocumentDetectionTimeout',
    DocumentCloseButtonClicked: 'DocumentCloseButtonClicked',
    DocumentProcessRestarted: 'DocumentProcessRestarted',
    DocumentOrientationStyleChanged: 'DocumentOrientationStyleChanged',
    DocumentReviewImage: 'DocumentReviewImage',
};
export const XPRESSID_INFO_EVENTS_SELFIE_CODES = {
    SelfieProcessStarted: 'SelfieProcessStarted',
    SelfieMounted: 'SelfieMounted',
    SelfieUnmounted: 'SelfieUnmounted',
    SelfieRestartProcess: 'SelfieRestartProcess',
    SelfieProcessFinished: 'SelfieProcessFinished',
    SelfieCameraStarted: 'SelfieCameraStarted',
    SelfieCameraFailure: 'SelfieCameraFailure',
    SelfieRepeatClicked: 'SelfieRepeatClicked',
    SelfieFaceDetection: 'SelfieFaceDetection',
    SelfieCameraVideoPlayStarted: 'SelfieCameraVideoPlayStarted',
    SelfieCameraRecorderStop: 'SelfieCameraRecorderStop',
    SelfieRestartToken: 'SelfieRestartToken',
    SelfieSuccessTickFinish: 'SelfieSuccessTickFinish',
    SelfieRestartClicked: 'SelfieRestartClicked',
    SelfieDetectionTimeout: 'SelfieDetectionTimeout',
    SelfieOrientationChanged: 'SelfieOrientationChanged',
    SelfieMountFailure: 'SelfieMountFailure',
    SelfieDependenciesError: 'SelfieDependenciesError',
    SelfieCameraRecorderSetup: 'SelfieCameraRecorderSetup',
    SelfieCameraRecorderSetupError: 'SelfieCameraRecorderSetupError',
    SelfieCloseButtonClicked: 'SelfieCloseButtonClicked',
    SelfieContinueClicked: 'SelfieContinueClicked',
    SelfieProcessRestarted: 'SelfieProcessRestarted',
    SelfieOrientationStyleChanged: 'SelfieOrientationStyleChanged',
    SelfieReviewImage: 'SelfieReviewImage',
};
export const XPRESSID_INFO_EVENTS_VIDEO_CODES = {
    VideoProcessStarted: 'VideoProcessStarted',
    VideoMounted: 'VideoMounted',
    VideoUnmounted: 'VideoUnmounted',
    VideoProcessFinished: 'VideoProcessFinished',
    VideoRestartProcess: 'VideoRestartProcess',
    VideoCameraStarted: 'VideoCameraStarted',
    VideoCaptureDetection: 'VideoCaptureDetection',
    VideoCameraVideoPlayStarted: 'VideoCameraVideoPlayStarted',
    VideoCameraRecorderStop: 'VideoCameraRecorderStop',
    VideoSuccessTickFinish: 'VideoSuccessTickFinish',
    VideoRestartClicked: 'VideoRestartClicked',
    VideoOrientationChanged: 'VideoOrientationChanged',
    VideoMountFailure: 'VideoMountFailure',
    VideoDependenciesError: 'VideoDependenciesError',
    VideoDetectionTimeout: 'VideoDetectionTimeout',
    VideoCameraFailure: 'VideoCameraFailure',
    VideoCameraRecorderSetup: 'VideoCameraRecorderSetup',
    VideoCloseButtonClicked: 'VideoCloseButtonClicked',
    VideoProcessRestarted: 'VideoProcessRestarted',
    VideoOrientationStyleChanged: 'VideoOrientationStyleChanged',
};

export const CLOSE_BUTTON_CLICKED_CODES = [
    XPRESSID_INFO_EVENTS_DOCUMENT_CAPTURE_CODES.DocumentCloseButtonClicked,
    XPRESSID_INFO_EVENTS_SELFIE_CODES.SelfieCloseButtonClicked,
    XPRESSID_INFO_EVENTS_VIDEO_CODES.VideoCloseButtonClicked,
];
